import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Dialog,
  DialogContent,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  List,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import DeleteIcon from '@mui/icons-material/Delete';
import { Autocomplete as MUIAutocomplete } from "@mui/material";
import { Autocomplete } from "@react-google-maps/api";

import AddIcon from "@mui/icons-material/Add";
import * as Yup from "yup";
import { imgWatermark, UploadMedia, Uploadpdf, UploadVideo } from "../../utils/uploadMedia";
import { errorToast, successToast, warnToast } from "../../helpers/toast";
import { generateEncryptedKeyBody } from "../../utils/crypto";

import { useFormik } from "formik";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { CommonBody, PropertyType, PropertyValues } from "../../types/General";
import {
  useEditPropertyMutation,
  useLazyGetSpecificPropertyByIdQuery,
  usePostAddPropertyMutation,
  useLazyGetpropertyTypeOffplanListingQuery,
  useLazyGetAmenitiesListingQuery,
} from "../../services/property";

import { useLazyGetAllCategoriesQuery, useLazyGetAllCategoryQuery } from "../../services/category";
import Loader from "../../helpers/constants/Loader";
import {
  useLazyGetAllTypeOfCompaniesQuery,
  useLazyGetPendingAgentQuery,
  useLazyGetPendingCompanyQuery,
} from "../../services/users";
import { useLazyGetAllpropertyStatusQuery } from "../../services/propertyStatus";
import moment from "moment";
import { isNumber, isNumberPrice } from "../../utils/validation";
import PhoneInput from "react-phone-input-2";
import DragAndDrop from "../../components/DragAndDrop";
import EditText from "../../components/EditText";
import { ROLE } from "../../constants/enums";


interface PaymentPlan {
  downPaymentPercent: string;
  downPaymentInstallments: string;
  duringConsPercent: string;
  duringConsInstallments: string;
  onHandoverPercent: string;
  onHandoverInstallments: string;
}
interface PaymentPlanNumber {
  downPaymentPercent: number;
  downPaymentInstallments: number;
  duringConsPercent: number;
  duringConsInstallments: number;
  onHandoverPercent: number;
  onHandoverInstallments: number;
}

interface Layout {
  floorImage: string;
  layoutType: string;
  size: number | string;
}

interface Units {
  beds: string;
  countryISO: string;
  dialCode: string;
  enquiryNo: string;
  price: number | string;
  size: number | string;
  layouts: Layout[]
}

const AddOffPlanProperty = () => {
  const [ByIdDetails, setByIdDetails] = useState<PropertyValues | any>();
  //console.log('ByIdDetails :', ByIdDetails);
  const [isLoading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const { _id } = useParams();
  const [places, setPlaces] = useState<any[]>([]);
  const [waterMark, setWaterMark] = useState<string>("")
  console.log('waterMark :', waterMark);
  const targetRef: any = useRef(null);
  const today = new Date().toISOString().split("T")[0];
  const [addProperties] = usePostAddPropertyMutation();
  const [updateProperty] = useEditPropertyMutation();
  const [fetchApi] = useLazyGetSpecificPropertyByIdQuery();
  const [propertyTypeList] = useLazyGetpropertyTypeOffplanListingQuery();
  const [amenitiesTypeList] = useLazyGetAmenitiesListingQuery();
  const [paymentPlan, setPaymentPlan] = useState<string>("2");
  const [unitsObject, setUnitsObject] = useState<Units>({
    beds: "",
    enquiryNo: "",
    price: "",
    size: "",
    countryISO: "AE",
    dialCode: "+971",
    layouts: []
  });
  const [unitsArray, setUnitsArray] = useState<Units[]>([]);
  const [layoutObject, setLayoutObject] = useState<Layout>({
    floorImage: "",
    layoutType: "",
    size: ""
  })
  const [interiorImages, setInteriorImages] = useState<string[]>([]);
  const [exteriorImages, setExteriorImages] = useState<string[]>([]);
  const [gardenImages, setGardenImages] = useState<string[]>([]);
  const imageHandlers = [setInteriorImages, setExteriorImages, setGardenImages];
  const imageMap: { [key in 0 | 1 | 2]: string[] } = {
    0: interiorImages,
    1: exteriorImages,
    2: gardenImages,
  };
  const [value, setValue] = useState<number>(0);
  const images = imageMap[value as 0 | 1 | 2] || interiorImages;
  const setImages = imageHandlers[value];
  const [showLayout, setShowLayout] = useState<boolean>(false)
  const [paymentPlanArray, setPaymentPlanArray] = useState<PaymentPlanNumber[]>([]);
  const [paymentObject, setPaymentObject] = useState<PaymentPlan>({
    downPaymentPercent: "",
    downPaymentInstallments: "",
    duringConsPercent: "",
    duringConsInstallments: "",
    onHandoverPercent: "",
    onHandoverInstallments: "",
  })


  const [categories, setCategories] = useState<{ _id: string; name: string }[]>(
    []
  );
  const [amennity, setAmenity] = useState<{ _id: string; name: string }[]>([
    {
      _id: "",
      name: "",
    },
  ]);
  const [getAllSubcategory] = useLazyGetAllCategoriesQuery();
  const [subCategories, setSubCategories] = useState<any>([]);
  const [companyListingApi] = useLazyGetAllTypeOfCompaniesQuery();
  const [companyListing, setCompanyListing] = useState<any>([]);
  const [companyId, setCompanyId] = useState<string>("");
  const [autocomplete, setAutocomplete] = useState<any>();
  const [rows, setRows] = useState<PropertyType[]>([]);
  const [fetchAll] = useLazyGetAllpropertyStatusQuery();
  const [fetchAllCategory] = useLazyGetAllCategoryQuery();
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [avlStartDate, setAvlStartDate] = useState<string>("");
  const [avlEndDate, setAvlEndDate] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  //console.log('description :', description);


  const handleCrossClick = (e: React.MouseEvent, i: number) => {
    e.stopPropagation();
    let res = [...imageMap[value as 0 | 1 | 2]];
    res?.splice(i, 1);
    imageHandlers[value]([...res]);
  };


  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleImageUpload1 = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    try {
      const res = await UploadMedia(file);
      if (res?.statusCode === 200) {
        const imageUrl = res?.data[0]?.location;
        setLayoutObject({ ...layoutObject, floorImage: imageUrl });
        successToast("Image uploaded successfully.");
      } else {
        errorToast(res?.message);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      errorToast("Error uploading image. Please try again.");
    }
  };


  const handleAmenities = (event: SelectChangeEvent<string[]>) => {
    if (event?.target?.value) {
      formik.setFieldValue("amenitiesId", event.target?.value);
    }
  };



  const handleChangePhone = (phone: any, country: any) => {
    setUnitsObject({ ...unitsObject, enquiryNo: phone?.replace(country?.dialCode, ""), dialCode: country?.dialCode.includes("+") ? "" : "+" + country?.dialCode, countryISO: country?.countryCode ? country?.countryCode.toUpperCase() : "" });

  };


  const fetchLocations = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}common/locations.json`,
      );
      const data = await response.json();
      const arr = data?.map((item: { key: any; value: any }) => ({
        label: item?.value,
        value: item?.key || "",
      }));
      setPlaces(arr);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };


  const handleAddPaymentObject = () => {
    if (Number(paymentObject.downPaymentPercent) + Number(paymentObject.duringConsPercent) + Number(paymentObject.onHandoverPercent) !== 100) {
      warnToast("Total percentage must equal 100%. Please adjust the values");
      return;
    } else if (paymentPlanArray?.length === 3) {
      warnToast("You can only add 3 payment plans");
      return;
    } else {
      let obj = {
        downPaymentPercent: Number(paymentObject.downPaymentPercent),
        downPaymentInstallments: Number(paymentObject.downPaymentInstallments),
        duringConsPercent: Number(paymentObject.duringConsPercent),
        duringConsInstallments: Number(paymentObject.duringConsInstallments),
        onHandoverPercent: Number(paymentObject.onHandoverPercent),
        onHandoverInstallments: Number(paymentObject.onHandoverInstallments),
      }
      setPaymentPlanArray((prevArray) => [...prevArray, obj])
      setPaymentObject({
        downPaymentPercent: "",
        downPaymentInstallments: "",
        duringConsPercent: "",
        duringConsInstallments: "",
        onHandoverPercent: "",
        onHandoverInstallments: "",
      })
    }
  }


  const handleAddUnits = () => {
    if (!unitsObject.beds || !unitsObject.price || !unitsObject.size) {
      warnToast("Please fill all the fields");
      return;
    } else {
      let obj = {
        beds: unitsObject?.beds,
        enquiryNo: unitsObject.enquiryNo ? unitsObject.enquiryNo : "",
        dialCode: !unitsObject.enquiryNo ? "" : unitsObject.dialCode ? unitsObject.dialCode : "",
        countryISO: unitsObject.countryISO ? unitsObject.countryISO : "",
        layouts: [],
        size: Number(unitsObject.size),
        price: Number(unitsObject.price)
      }

      setUnitsArray((prev) => [...prev, obj])
      setUnitsObject({
        beds: "",
        enquiryNo: "",
        layouts: [],
        size: "",
        price: "",
        dialCode: "+971",
        countryISO: "AE",
      })
    }
  }


  const handlePdfUpload = async (
    event: React.ChangeEvent<HTMLInputElement>, field: string
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;
    if (file && file.type !== "application/pdf") {
      warnToast("Please upload a PDF file.");
      return;
    }
    try {
      if (!file) {
        formik.setFieldValue(field, null);
        return;
      }
      let res;
      res = await Uploadpdf(file);
      if (res?.statusCode === 200) {
        formik.setFieldValue(field, res?.data?.[0]?.location); // Assuming pdfUrl is the URL of the uploaded PDF
      } else {
        errorToast(res?.message);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      errorToast("Error uploading file. Please try again.");
    }
  };

  const handleAddLayout = (i: number) => {
    if (!layoutObject.layoutType || !layoutObject.size) {
      warnToast("Please fill layout type and size");
      return;
    } else {
      let obj = {
        layoutType: layoutObject.layoutType,
        size: layoutObject.size,
        floorImage: layoutObject.floorImage || ""
      }

      setUnitsArray((prev) => prev?.map((data, index) => {
        if (index === i) {
          return { ...data, layouts: [...data.layouts, obj] }
        } else {
          return data;
        }
      }));
      setLayoutObject({
        layoutType: "",
        size: "",
        floorImage: ""
      })
      setShowLayout(false)
    }
  }

  const handleDeletePaymentObject = (i: number) => {
    setPaymentPlanArray((prev) => prev.filter((data, index) => (index != i)))
  }

  const handleDeleteUnit = (i: number) => {
    setUnitsArray((prev) => prev.filter((data, index) => (index != i)))
  }
  const handleDeleteLayout = (unitIndex: number, layoutIndex: number) => {
    setUnitsArray((prev) =>
      prev?.map((unit, index) => {
        if (index === unitIndex) {
          return {
            ...unit,
            layouts: unit.layouts.filter((_, idx) => idx !== layoutIndex),
          };
        }
        return unit;
      })
    );
  };



  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {

    const files = event.target.files;
    const allowedLength = Array.from(files || []).length;
    if (Array.from(files || []).length > 20) {
      errorToast('Max limit is upto 20 images');
      event.target.value = '';
      return;
    }

    const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
    const allowedVideoTypes = ['video/mp4', 'video/avi', 'video/mkv'];
    const invalidFiles = Array.from(files || []).filter(
      (file) =>
        !allowedTypes.includes(file.type) &&
        !allowedVideoTypes.includes(file.type),
    );
    if (invalidFiles.length > 0) {
      errorToast('Inavlid  type');
      event.target.value = '';
      return;
    }

    if (
      interiorImages.length +
      exteriorImages.length +
      gardenImages.length +
      allowedLength >
      20
    ) {
      errorToast('Max limit is upto 20 images');
      event.target.value = '';
      return;
    }

    const videoFiles = Array.from(files || []).filter((file) =>
      allowedVideoTypes.includes(file.type),
    );

    let validVideos = true;

    await Promise.all(
      videoFiles?.map(
        (file) =>
          new Promise<void>((resolve) => {
            const videoElement = document.createElement('video');
            videoElement.preload = 'metadata';

            videoElement.onloadedmetadata = function () {
              window.URL.revokeObjectURL(videoElement.src);
              if (videoElement.duration > 120) {
                validVideos = false;
                errorToast('Video duration exceeds the limit of 2 minutes');
              }
              resolve();
            };

            videoElement.src = URL.createObjectURL(file);
          }),
      ),
    );

    if (!validVideos) {
      event.target.value = '';
      return;
    }

    setLoading(true);
    const resArray = await Promise.all(
      Array.from(files || [])?.map(async (file) => {
        if (allowedTypes.includes(file.type)) {
          try {
            const watermarkedImage = await imgWatermark(
              file,
              waterMark,
            );
            setLoading(false)
            return UploadMedia(watermarkedImage);
          } catch (error: any) {
            errorToast("Something went wrong")
          }
        } else if (allowedVideoTypes.includes(file.type)) {
          return UploadVideo(file);
        }
        return null;
      }),
    );
    setLoading(false);
    resArray?.map((res) => {
      if (res?.statusCode === 200) {
        const { location } = res?.data[0];

        if (imageHandlers[value]) {
          imageHandlers[value]((prev) => [...prev, location]);
        }
        setLoading(false);

        event.target.value = '';
        return;

      } else {
        errorToast(res?.message as string);
        setLoading(false);
        event.target.value = '';
      }
    });
  };


  const [searchParams, setSearchParams] = useSearchParams();
  const onLoad = (autocompleteObj: any) => {
    setAutocomplete(autocompleteObj);
  };
  const onPlaceChanged = async () => {
    if (autocomplete) {
      let place: any = await (autocomplete as any)?.getPlace();

      if (place && place?.address_components) {
        let address = place?.address_components;

        let state,
          city,
          country,
          zip = "";

        address?.forEach(function (component: any) {
          let types = component?.types;

          if (
            types?.indexOf("locality") > -1 ||
            types?.indexOf("administrative_area_level_3") > -1
          ) {
            city = component?.long_name;
          }
          if (types.indexOf("postal_code") > -1) {
            zip = component?.long_name;
          }
          if (types.indexOf("administrative_area_level_1") > -1) {
            state = component?.long_name || "";
          }
          if (types.indexOf("country") > -1) {
            country = component?.long_name || "";
          }
        });
        var lat = place?.geometry?.location?.lat();
        var lng = place?.geometry?.location?.lng();
        formik.setFieldValue("address", place?.formatted_address);
        formik.setFieldValue("latitude", lat || 0);
        formik.setFieldValue("longitude", lng || 0);
      }
    }
  };

  const fetchDataById = async (id: any) => {
    try {
      const response = await fetchApi({
        userId: id,
        isDraft: Boolean(searchParams?.get("draft")),
      }).unwrap();
      if (response.statusCode === 200) {
        setByIdDetails(response?.data || []);
        setDescription(response?.data?.specifications || "")
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await fetchAllCategory({
        limit: 100,
        page: 1,
        search: "",
        type: "category",
        parentId: "",
      }).unwrap();
      setCategories(response?.data?.category || []);
    } catch (e: any) {
      errorToast(e?.message || e?.data?.message);
    }
  };

  const fetchSubCatgeories = async () => {
    try {
      const response = await getAllSubcategory({
        type: "subcategory",
        parentId: formik.values.category || "",
        limit: 100
      }).unwrap();
      setSubCategories(response?.data?.category || []);
    } catch (e: any) {
      errorToast(e?.message || e?.data?.message);
    }
  };



  const fetchPropertyType = async () => {
    try {
      const response = await propertyTypeList({ isOffPlanProjects: true }).unwrap();
      formik.setFieldValue("propertyTypeId", response?.data?.[0]?._id)

    } catch (e: any) {
      errorToast(e?.message || e?.data?.message);
    }
  };

  const fetchAmenities = async () => {
    try {
      const response = await amenitiesTypeList({}).unwrap();
      setAmenity(response?.data || []);
    } catch (e: any) {
      errorToast(e?.message || e?.data?.message);
    }
  };

  const List = async (search: string) => {
    try {
      const response = await fetchAll({ search: search }).unwrap();
      setRows(response?.data?.PropertyCondition || []);
    } catch (e: any) {
      errorToast(e?.message || e?.data?.message);
    }
  };

  const handleDateChange = (event: any) => {
    formik.setFieldValue("constructionDate", event.target.value || "");
    const selectedDate = new Date(event.target.value);
    if (!isNaN(selectedDate.getTime())) {
      const utcDate = moment(selectedDate).format('YYYY-MM-DDTHH:mm:ss[Z]')
      setStartDate(utcDate);
    } else {
      console.error("Invalid date selected");
    }
  };

  const handleDateChangeAvlStart = (event: any) => {
    formik.setFieldValue("availableDateFrom", event.target.value || "");
    const selectedDate = new Date(event.target.value);
    if (!isNaN(selectedDate.getTime())) {
      const utcDate = moment(selectedDate).format('YYYY-MM-DDTHH:mm:ss[Z]')
      setAvlStartDate(utcDate);
    } else {
      console.error("Invalid date selected");
    }
  };

  const handleDateChangeAvlEnd = (event: any) => {
    formik.setFieldValue("availableDateTo", event.target.value || "");
    const selectedDate = new Date(event.target.value);
    if (!isNaN(selectedDate.getTime())) {
      const utcDate = moment(selectedDate).format('YYYY-MM-DDTHH:mm:ss[Z]')
      setAvlEndDate(utcDate);
    } else {
      console.error("Invalid date selected");
    }
  };

  const handleDateChange1 = (event: any) => {
    formik.setFieldValue("deliveryDate", event.target.value || "");
    const selectedDate = new Date(event.target.value);
    if (!isNaN(selectedDate.getTime())) {
      const utcDate = moment(selectedDate).format('YYYY-MM-DDTHH:mm:ss[Z]')
      setEndDate(utcDate);
    } else {
      console.error("Invalid date selected");
    }
  };

  function formatNumberWithCommas(value: string | number) {
    const valueStr = typeof value === 'number' ? value.toFixed(2) : value;
    const [integer, decimal] = valueStr.split('.');
    const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    let result = decimal !== undefined ? `${formattedInteger}.${decimal}` : formattedInteger;
    return result;
  }

  const formik = useFormik({
    initialValues: {
      name: "",
      price: "",
      address: "",
      specifications: "",
      advertisementPermitNo: "",
      category: "",
      amenitiesId: [],
      latitude: 0,
      longitude: 0,
      propertyTypeId: "",
      area: "",
      companyName: "",
      agentName: "",
      agentId: "",
      companyId: "",
      constructionDate: "",
      deliveryDate: "",
      offPlanType: "",
      subCategory: "",
      country: "",
      keyFeature: "",
      beds: "",
      baths: "",
      financialStatus: "",
      availableDateFrom: "",
      availableDateTo: "",
      floorPlan: "",
      SPA: "",
      projectBrochure: "",
      subCategoryName: ""
    },

    validationSchema: Yup.object().shape({
      // name: Yup.string().required("Property Name is required"),
      // price: Yup.string()
      //   .required("Price is required")
      //   .max(10, "Price must be less than 10 characters"),
      // address: Yup.string().required("Address is required"),
      // advertisementPermitNo: Yup.string().required("Permit Number is required"),
      // companyName: Yup.string().required("Please select a company"),
      // category: Yup.string().required("Category is required"),
      // offPlanType: Yup.string().required("Project type is required"),
      // subCategory: Yup.string().required("Sub-Category is required"),
      // amenitiesId: Yup.array()
      //   .min(1, "Please select amenity")
      //   .required("Amenities are required"),
    }),

    onSubmit: async (values: any) => {
      formik.setSubmitting(true);

      if (interiorImages?.length + exteriorImages?.length + gardenImages?.length < 3) {
        warnToast("Please Upload minimum 3 Images")
        return;
      }

      if (!companyId) {
        warnToast("Please select an company");
        return;
      }

      // if (description?.length <= 8) {
      //   warnToast("Please add Description");
      //   return;
      // }


      const body: any = {};

      if (values?.name) {
        body.name = values.name;
      }
      if (values?.price) {
        body.price = Number(String(values.price).replace(/,/g, ''));
      }
      if (values?.address) {
        body.address = values.address;
      }
      if (values?.beds) {
        body.beds = values.beds;
      }
      if (values?.offPlanType) {
        body.offPlanType = Number(values.offPlanType);
      }
      if (values?.baths) {
        body.baths = values.baths;
      }
      if (values?.financialStatus) {
        body.finacialStatus = values.financialStatus;
      }
      if (description?.length > 7) {
        body.specifications = description;
      }
      if (values?.keyFeature
      ) {
        body.keyFeature
          = values.keyFeature;
      }


      if (values?.advertisementPermitNo) {
        body.advertisementPermitNo = values.advertisementPermitNo;
      }
      if (values?.area) {
        body.area = values.area;
      }
      if (values?.SPA) {
        body.SPA = values.SPA;
      }
      if (values?.projectBrochure) {
        body.projectBrochure = values.projectBrochure;
      }
      if (values?.floorPlan) {
        body.floorPlan = values.floorPlan;
      }
      if (values?.category) {
        body.categoryParentId = values.category;
      }
      if (values?.country) {
        body.locationId = values.country;
      }
      if (values?.subCategory) {
        body.categoryId = values.subCategory;
      }
      if (interiorImages?.length) {
        body.interior = interiorImages;
      }
      if (exteriorImages?.length) {
        body.exterior = exteriorImages;
      }
      if (gardenImages?.length) {
        body.garden = gardenImages;
      }
      if (unitsArray?.length) {
        body.units = unitsArray;
      }
      if (paymentPlanArray?.length) {
        body.paymentPlans = paymentPlanArray;
      }

      if (values?.amenitiesId) {
        body.amenitiesId = values.amenitiesId;
      }
      if (values?.latitude) {
        body.latitude = values.latitude;
      }
      if (values?.longitude) {
        body.longitude = values.longitude;
      }
      if (values?.propertyTypeId) {
        body.propertyTypeId = values.propertyTypeId;
      }
      if (companyId) {
        body.companyId = companyId;
      }
      if (selectedAgentId) {
        body.agentId = selectedAgentId;
      }

      if (values?.deliveryDate) {
        body.deliveryDate = endDate;
      }
      if (values?.constructionDate) {
        body.constructionDate = startDate;
      }
      if (values?.availableDateFrom) {
        body.availableDateFrom = avlStartDate;
      }
      if (values?.availableDateTo) {
        body.availableDateTo = avlEndDate;
      }
      body.isOffPlanProjects = true;
      body.isAssignedToAgent = true;

      body.images = [
        ...interiorImages,
        ...exteriorImages,
        ...gardenImages,
      ]

      if (searchParams.get("draft")) {
        body["draftId"] = _id;
      }

      //console.log(body, "body");

      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      setLoading(true)
      try {
        if (!_id || Boolean(searchParams.get("draft"))) {
          const response = await addProperties(encryptedBody).unwrap();
          if (response?.statusCode === 200) {
            successToast("Properties Added Successfully.");
            navigate("/off-plan-listing");
          }
        } else {
          const response = await updateProperty({
            id: _id,
            body: encryptedBody,
          }).unwrap();
          if (response?.statusCode === 200) {
            successToast("Property Updated Successfully.");
            navigate("/off-plan-listing");
          }
        }
        setLoading(false)
      } catch (error: any) {
        errorToast(error?.data?.message);
        setLoading(false)
      } finally {
        formik.setSubmitting(false);
        setLoading(false)
      }
    },
  });

  const saveDraft = async () => {

    if (interiorImages?.length + exteriorImages?.length + gardenImages?.length < 3) {
      warnToast("Please Upload minimum 3 Images")
      return;
    }

    if (formik.values.name === "") {
      warnToast("Property Name is required")
      return;
    }

    if (formik.values.price === "") {
      warnToast("Property price is required")
      return;
    }
    const values = formik?.values;
    const body: any = {};

    if (values?.name) {
      body.name = values.name;
    }
    if (values?.price) {
      body.price = Number(String(values.price).replace(/,/g, ''));
    }
    if (values?.address) {
      body.address = values.address;
    }
    if (values?.beds) {
      body.beds = values.beds;
    }
    if (values?.offPlanType) {
      body.offPlanType = Number(values.offPlanType);
    }
    if (values?.baths) {
      body.baths = values.baths;
    }
    if (values?.financialStatus) {
      body.finacialStatus = values.financialStatus;
    }
    if (description?.length > 7) {
      body.specifications = description;
    }
    if (values?.keyFeature
    ) {
      body.keyFeature
        = values.keyFeature;
    }


    if (values?.advertisementPermitNo) {
      body.advertisementPermitNo = values.advertisementPermitNo;
    }
    if (values?.area) {
      body.area = values.area;
    }
    if (values?.SPA) {
      body.SPA = values.SPA;
    }
    if (values?.projectBrochure) {
      body.projectBrochure = values.projectBrochure;
    }
    if (values?.floorPlan) {
      body.floorPlan = values.floorPlan;
    }
    if (values?.category) {
      body.categoryParentId = values.category;
    }
    if (values?.country) {
      body.locationId = values.country;
    }
    if (values?.subCategory) {
      body.categoryId = values.subCategory;
    }
    if (interiorImages?.length) {
      body.interior = interiorImages;
    }
    if (exteriorImages?.length) {
      body.exterior = exteriorImages;
    }
    if (gardenImages?.length) {
      body.garden = gardenImages;
    }
    if (unitsArray?.length) {
      body.units = unitsArray;
    }
    if (paymentPlanArray?.length) {
      body.paymentPlans = paymentPlanArray;
    }

    if (values?.amenitiesId) {
      body.amenitiesId = values.amenitiesId;
    }
    if (values?.latitude) {
      body.latitude = values.latitude;
    }
    if (values?.longitude) {
      body.longitude = values.longitude;
    }
    if (values?.propertyTypeId) {
      body.propertyTypeId = values.propertyTypeId;
    }
    if (companyId) {
      body.companyId = companyId;
    }
    if (selectedAgentId) {
      body.agentId = selectedAgentId;
    }

    if (values?.deliveryDate) {
      body.deliveryDate = endDate;
    }
    if (values?.constructionDate) {
      body.constructionDate = startDate;
    }
    if (values?.availableDateFrom) {
      body.availableDateFrom = avlStartDate;
    }
    if (values?.availableDateTo) {
      body.availableDateTo = avlEndDate;
    }
    body.isOffPlanProjects = true;

    body.images = [
      ...interiorImages,
      ...exteriorImages,
      ...gardenImages,
    ]

    body.isOffPlanProjects = true;
    body.isDraftSaved = true;

    //console.log(body, "body11");

    const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;

    try {
      if (!_id) {
        const response = await addProperties(encryptedBody).unwrap();
        if (response?.statusCode === 200) {
          successToast("Properties drafted successfully.");
          navigate("/off-plan-listing");
        }
      } else {
        const response = await updateProperty({
          id: _id,
          body: encryptedBody,
        }).unwrap();
        if (response?.statusCode === 200) {
          successToast("Property drafted successfully.");
          navigate("/off-plan-listing");
        }
      }
    } catch (error: any) {
      errorToast(error?.data?.message);
    } finally {
      formik.setSubmitting(false);
    }
  };
  const [indexForAddLayout, setIndexForAddLayout] = useState<number>(0);
  const [getApprovedCompany] = useLazyGetPendingAgentQuery();
  const [agentsData, setAgentsData] = useState([]);
  const [selectedAgentId, setSelectedAgentId] = useState("");
  const fetchApproved = async (role: number, page: number, search: string) => {
    setLoading(true);
    try {
      const response = await getApprovedCompany({
        page: page,
        search: "",
        limit: 200,
        parentId: companyId,
        isAdminAprooved: 2,
        startDate: "",
        endDate: "",
      }).unwrap();
      if (response.statusCode === 200) {
        setLoading(false);
        setAgentsData(response?.data?.user);
        if (!response?.data?.user?.length)
          warnToast("This company dont have any agents");
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  //console.log(formik.values.propertyTypeId, "formik.values.propertyTypeId ");

  const scrollToElement = (target: any) => {
    window.scrollTo({
      top: target,
      behavior: "smooth",
    });
  };
  //console.log(formik.values.country, "90909090");
  //console.log(formik?.values?.category, "formik?.values?.category");

  useEffect(() => {
    fetchCategories();
    fetchAmenities();
    fetchPropertyType();
    fetchCompanyListing();
    fetchLocations();
    List("");
  }, []);
  useEffect(() => {
    if (_id) fetchDataById(_id);
  }, [_id]);
  useEffect(() => {
    if (ByIdDetails) {
      //console.log(ByIdDetails?.categoryId?._id, 'ByIdDetails?.categoryId?._id');

      // @ts-ignore
      formik.setValues({
        name: ByIdDetails?.name || "",
        price: ByIdDetails?.price ? formatNumberWithCommas(String(ByIdDetails?.price)) : "",
        address: ByIdDetails?.address || "",
        beds: ByIdDetails?.beds || "",
        baths: ByIdDetails?.baths || "",
        financialStatus: String(ByIdDetails?.finacialStatus) || "",
        area: ByIdDetails?.area || "",
        SPA: ByIdDetails?.SPA || "",
        projectBrochure: ByIdDetails?.projectBrochure || "",
        floorPlan: ByIdDetails?.floorPlan || "",
        offPlanType: String(ByIdDetails?.offPlanType) || "",
        specifications: ByIdDetails?.specifications || "",
        keyFeature: ByIdDetails?.keyFeature || "",
        propertyTypeId: ByIdDetails?.propertyTypeId?._id || "",
        category: ByIdDetails?.categoryParentId?._id || "",
        subCategory: ByIdDetails?.categoryId?._id || "",
        country: ByIdDetails?.locationId || "",
        amenitiesId: ByIdDetails?.amenities?.map((item: { _id: any }) => item?._id) || [],
        advertisementPermitNo: ByIdDetails?.advertisementPermitNo || "",
        latitude: ByIdDetails?.latitude || 0,
        longitude: ByIdDetails?.longitude || 0,
        companyName: ByIdDetails?.companyId?._id || "",
        agentName: ByIdDetails?.agentId?._id || "",
        deliveryDate: moment(ByIdDetails?.deliveryDate).format("YYYY-MM-DD") || "",
        constructionDate: moment(ByIdDetails?.constructionDate).format("YYYY-MM-DD") || "",
        availableDateFrom: moment(ByIdDetails?.availableDateFrom).format("YYYY-MM-DD") || "",
        availableDateTo: moment(ByIdDetails?.availableDateTo).format("YYYY-MM-DD") || "",
      });
      setSelectedAgentId(ByIdDetails?.agentId?._id || "");
      setCompanyId(ByIdDetails?.companyId?._id || "");
      setInteriorImages(ByIdDetails?.interior || [])
      setExteriorImages(ByIdDetails?.exterior || [])
      setGardenImages(ByIdDetails?.garden || [])
      setPaymentPlanArray(ByIdDetails?.paymentPlans || [])
      setUnitsArray(ByIdDetails?.units || [])
    }
  }, [ByIdDetails]);





  useEffect(() => {
    if (formik.values.category) {

      fetchSubCatgeories()
    }
  }, [formik.values.category])

  const fetchCompanyListing = async () => {
    try {
      const res = await companyListingApi({
        role: ROLE.AGENCY,
        agencyType: 1
      }).unwrap();
      if (res?.statusCode === 200) {
        setCompanyListing(res?.data);
      }
    } catch (error: any) {
      //console.log(error?.data?.message);
    }
  };
  useEffect(() => {
    if (companyId) fetchApproved(3, 1, "");
  }, [companyId]);


  useEffect(() => {
    if (showLayout) {
      scrollToElement(targetRef.current.offsetTop)
    }
  }, [showLayout])





  return (
    <div>
      <Loader isLoad={isLoading} />
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">{_id ? "Edit Off-Plan Property" : "Add Off-Plan Property"}</h1>
          <Button
            className="btn btn_primary"
            onClick={() =>
              navigate(
                "/off-plan-listing" +
                (Boolean(searchParams.get("draft")) ? "?draft=true" : ""),
                { replace: true }
              )
            }
          >
            Back
          </Button>
        </div>





        <Card className="cards">
          <form onSubmit={formik.handleSubmit}>
            <CardContent sx={{ p: 1 }}>
              <Grid container spacing={2}>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <Typography className="custom_label">Company Name</Typography>
                  {/* <Select
                    className="select_div"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="companyName"
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 250, // Adjust height
                          // width: 250,     // Adjust width
                        },
                      },
                    }}
                    fullWidth
                    value={formik?.values?.companyName || ""}
                    onChange={(e) =>
                      formik.setFieldValue("companyName", e.target?.value)
                    }
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched?.companyName &&
                      Boolean(formik.errors?.companyName)
                    }
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select
                    </MenuItem>
                    {companyListing?.length > 0 &&
                      companyListing?.map((item: any) => {
                        return (
                          <MenuItem
                            onClick={() => { setWaterMark(item?.image); setCompanyId(item?._id) }}
                            value={item?._id}
                          >
                            {item?.companyName + " (" + item?.referenceId + ")"}
                          </MenuItem>
                        );
                      })}
                  </Select>
                  {formik.touched?.companyName &&
                    formik.errors?.companyName && (
                      <Typography
                        sx={{ fontSize: "12px" }}
                        variant="caption"
                        color="red"
                      >
                        Please select a company
                      </Typography>
                    )} */}
                  <MUIAutocomplete
                    options={companyListing || []}
                    disabled={_id ? true : false}
                    getOptionLabel={(option: any) => option?.companyName + " (" + option?.referenceId + ")" || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select Company"
                        variant="outlined"
                        fullWidth
                        error={
                          formik.touched?.companyName &&
                          Boolean(formik.errors?.companyName)
                        }
                        onBlur={formik.handleBlur}
                        name="companyName"
                      />
                    )}
                    value={
                      companyListing?.find(
                        (item: any) =>
                          item?._id === companyId
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      formik.setFieldValue(
                        "companyName",
                        newValue?.companyName || ""
                      );
                      setCompanyId(newValue?._id || "");
                      setWaterMark(newValue?.image || '')
                    }}
                    isOptionEqualToValue={(option: any, value: any) =>
                      option?._id === value?._id
                    }
                  />
                </Grid>
                {agentsData?.length > 0 ? (
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Typography className="custom_label">
                      Assign Agent
                    </Typography>
                    <Select
                      className="select_div"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      // disabled={_id ? true : false}
                      name="agentName"
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 250, // Adjust height
                            // width: 250,     // Adjust width
                          },
                        },
                      }}
                      fullWidth
                      value={formik?.values?.agentName || ""}
                      onChange={(e) =>
                        formik.setFieldValue("agentName", e.target?.value)
                      }
                      onBlur={formik.handleBlur}
                      // error={
                      //   formik.touched?.agentName &&
                      //   Boolean(formik.errors?.agentName)
                      // }
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select
                      </MenuItem>
                      {agentsData?.length > 0 &&
                        agentsData?.map((item: any) => {
                          return (
                            <MenuItem
                              onClick={() => setSelectedAgentId(item?._id)}
                              value={item?._id}
                            >
                              {item?.name}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </Grid>
                ) : (
                  ""
                )}
                <Grid item xs={12} className="custom_tabs">
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="basic tabs example"
                    className="custom_tabs_links"
                  >
                    <Tab label="Interior Images" />
                    <Tab label="Exterior Images" />
                    <Tab label="Garden Images" />
                  </Tabs>
                  <Box className="upload_images_container">
                    <div className="upload_image upload_property">
                      <div className="gap_p">
                        <DragAndDrop
                          myImages={images}
                          setMyImages={setImages}
                          handleCrossClick={handleCrossClick}
                        />

                        {images?.length < 20 ? (
                          <label
                            htmlFor="icon-button-file"
                          >
                            <Input
                              sx={{ display: 'none' }}
                              id="icon-button-file"
                              type="file"
                              inputProps={{
                                accept: 'image/*,video/*',
                                multiple: true,
                              }}
                              onChange={handleImageUpload}
                              disabled={!companyId ? true : false}
                            />
                            <span className="upload_image_holder">
                              <AddIcon />
                              Upload Picture/Video
                            </span>
                          </label>
                        ) : null}
                      </div>
                    </div>
                  </Box>



                </Grid>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">
                    Property Name
                  </Typography>
                  <TextField
                    hiddenLabel
                    type={"text"}
                    name="name"
                    className="text_field"

                    variant="outlined"
                    disabled={_id ? true : false}
                    fullWidth
                    placeholder="Enter Property Name"
                    value={formik?.values?.name}
                    onChange={(val) => {
                      if (
                        val.target.value === " "

                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    error={formik.touched.name && Boolean(formik.errors.name)}
                    helperText={
                      formik.touched.name &&
                        typeof formik.errors.name === "string"
                        ? formik.errors.name
                        : undefined
                    }
                  />
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <FormControl fullWidth>
                    <Typography className="custom_label">
                      New Project Type
                    </Typography>

                    <Select
                      className="select_div"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      name="offPlanType"
                      value={
                        formik?.values?.offPlanType
                      }
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched?.offPlanType &&
                        Boolean(formik.errors?.offPlanType)
                      }
                      displayEmpty
                      onChange={formik.handleChange}

                    >
                      <MenuItem value="" disabled>
                        Select
                      </MenuItem>

                      <MenuItem

                        value="1"

                      >
                        Off-plan (Primary)
                      </MenuItem>
                      <MenuItem

                        value="2"
                      >
                        Off-plan (Secondary)
                      </MenuItem>

                    </Select>

                    {formik.touched?.offPlanType &&
                      typeof formik?.errors?.offPlanType === "string" && (
                        <Typography
                          sx={{ fontSize: "12px" }}
                          variant="caption"
                          color="red"
                        >
                          {formik.errors?.offPlanType}
                        </Typography>
                      )}
                  </FormControl>
                </Grid>


                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">{formik.values.offPlanType === "1" ? "Launch Price (AED)" : "Price (AED)"}</Typography>
                  <TextField
                    hiddenLabel
                    type={"text"}
                    name="price"
                    className="text_field"
                    variant="outlined"

                    fullWidth
                    placeholder="Enter Price"
                    value={formik?.values?.price}
                    onChange={(val) => {
                      let { value } = val.target;
                      const numericValue = value.replace(/,/g, '');
                      if (
                        isNumberPrice(numericValue) &&
                        numericValue.length <= 12
                      ) {
                        const formattedValue =
                          formatNumberWithCommas(numericValue);
                        formik.setFieldValue('price', formattedValue);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    error={formik.touched.price && Boolean(formik.errors.price)}
                    helperText={
                      formik.touched.price &&
                        typeof formik.errors.price === "string"
                        ? formik.errors.price
                        : undefined
                    }
                  />
                </Grid>



                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <FormControl fullWidth>
                    <Typography className="custom_label">Amenities</Typography>
                    <Select
                      className="select_div"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      name="amenitiesId"
                      value={formik?.values?.amenitiesId || []}
                      onChange={handleAmenities}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched?.amenitiesId &&
                        Boolean(formik.errors?.amenitiesId)
                      }
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 250, // Adjust height
                            width: 250,     // Adjust width
                          },
                        },
                      }}
                      displayEmpty
                      multiple
                      renderValue={(selected) =>
                        selected?.length > 0
                          ? selected
                            ?.map((value: any) => {
                              const amenity = amennity?.find(
                                (it: any) => it?._id === value
                              );
                              return amenity?.name;
                            })
                            .join(", ")
                          : "Select"
                      }
                    >
                      <MenuItem value="" disabled>
                        Select
                      </MenuItem>
                      {amennity?.length > 0
                        ? amennity?.map((it: any) => (
                          <MenuItem key={it?._id} value={it?._id}>
                            {it?.name}
                          </MenuItem>
                        ))
                        : ""}
                    </Select>
                    {formik.touched.amenitiesId &&
                      typeof formik.errors.amenitiesId === "string" && (
                        <Typography
                          sx={{ fontSize: "12px" }}
                          variant="caption"
                          color="red"
                        >
                          {formik.errors.amenitiesId}
                        </Typography>
                      )}
                  </FormControl>
                </Grid>




                <Grid item lg={4} md={6} sm={6} xs={12}>
                  <FormControl fullWidth>
                    <Typography className="custom_label">Category</Typography>
                    <Select
                      className="select_div"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      name="category"
                      value={formik?.values?.category || ""}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 250, // Adjust height
                            width: 250,     // Adjust width
                          },
                        },
                      }}
                      error={
                        formik.touched.category &&
                        Boolean(formik.errors.category)
                      }
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select
                      </MenuItem>
                      {categories?.length > 0
                        ? categories?.map((category: any) => (
                          <MenuItem key={category?._id} value={category?._id}>
                            {category?.name}
                          </MenuItem>
                        ))
                        : ""}
                    </Select>
                    {formik.touched?.category && formik.errors?.category && (
                      <Typography
                        sx={{ fontSize: "12px" }}
                        variant="caption"
                        color="red"
                      >
                        Please select a category
                      </Typography>
                    )}
                  </FormControl>
                </Grid>

                <Grid item lg={4} md={6} sm={6} xs={12}>
                  <FormControl fullWidth>
                    <Typography className="custom_label">Sub-Category</Typography>
                    <Select
                      className="select_div"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      name="subCategory"
                      value={subCategories?.length ? formik?.values?.subCategory || "" : ''}
                      // onChange={formik.handleChange}
                      onChange={(e) => {
                        const selectedSubCategory = subCategories.find(
                          (sub: any) => sub._id === e.target.value
                        );
                        formik.setFieldValue("subCategory", selectedSubCategory?._id || "");
                        formik.setFieldValue("subCategoryName", selectedSubCategory?.name || "");
                      }}
                      onBlur={formik.handleBlur}
                      disabled={!formik.values.category}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 250, // Adjust height
                            width: 250,     // Adjust width
                          },
                        },
                      }}
                      error={
                        formik.touched.subCategory &&
                        Boolean(formik.errors.subCategory)
                      }
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select
                      </MenuItem>
                      {subCategories?.length
                        ? subCategories?.map((subCategory: any) => (
                          <MenuItem key={subCategory?._id} value={subCategory?._id}>
                            {subCategory?.name}
                          </MenuItem>
                        ))
                        : ""}
                    </Select>
                    {formik.touched?.subCategory && formik.errors?.subCategory && (
                      <Typography
                        sx={{ fontSize: "12px" }}
                        variant="caption"
                        color="red"
                      >
                        Please select a sub-Category
                      </Typography>
                    )}
                  </FormControl>
                </Grid>


                {formik.values.offPlanType === "1" ? (
                  <>
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Typography className="custom_label">
                        Construction Date
                      </Typography>
                      <TextField
                        // hiddenTypography
                        type="date"
                        name="constructionDate"
                        variant="outlined"
                        fullWidth
                        placeholder="Start date"
                        className="text_field"
                        inputProps={{ maxLength: 30, max: today }}
                        value={formik.values.constructionDate}
                        onChange={handleDateChange}
                        InputProps={{
                          endAdornment: formik.values.constructionDate && (
                            <InputAdornment position="end" className="eye_btn">
                              <IconButton
                                onClick={() => {
                                  setStartDate("");
                                  formik.setFieldValue("constructionDate", "");
                                }}
                              >
                                <ClearIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                      {formik.touched.constructionDate &&
                        formik.errors.constructionDate && (
                          <FormHelperText sx={{ color: "red" }}>
                            {String(formik.errors.constructionDate)}
                          </FormHelperText>
                        )}
                    </Grid>

                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Typography className="custom_label">
                        Delivery Date
                      </Typography>
                      <TextField

                        type="date"
                        name="deliveryDate"
                        variant="outlined"
                        fullWidth
                        placeholder="End date"
                        className="text_field"
                        inputProps={{ maxLength: 30, min: today }}
                        value={formik.values.deliveryDate}

                        onChange={(e) => {
                          const value = e.target.value;
                          const year = value.split("-")[0]; // Extract the year part
                          if (year.length > 4 || parseInt(year, 10) > 9999) {
                            e.preventDefault(); // Prevent the change
                            return;
                          }
                          formik.setFieldValue("deliveryDate", value); // Update Formik field
                          handleDateChange1(e); // Call your custom handler
                        }}
                        InputProps={{
                          endAdornment: formik.values.deliveryDate && (
                            <InputAdornment position="end" className="eye_btn">
                              <IconButton
                                onClick={() => {
                                  setEndDate("");
                                  formik.setFieldValue("deliveryDate", "");
                                }}
                              >
                                <ClearIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                      {formik.touched.deliveryDate &&
                        formik.errors.deliveryDate && (
                          <FormHelperText sx={{ color: "red" }}>
                            {String(formik.errors.deliveryDate)}
                          </FormHelperText>
                        )}
                    </Grid>
                  </>
                ) : ("")}




                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <div className="control_group w_50">
                    <Typography className="custom_label">Address</Typography>
                    <Autocomplete
                      onLoad={onLoad}
                      onPlaceChanged={() => onPlaceChanged()}
                      options={{
                        types: ['establishment', 'geocode'],
                        componentRestrictions: { country: 'ae' },
                      }}
                    >
                      <TextField
                        className="text_field"
                        hiddenLabel
                        name="address"
                        value={formik?.values?.address || ""}
                        placeholder="Enter Address"
                        fullWidth
                        helperText={
                          formik.touched.address &&
                            typeof formik.errors.address === "string"
                            ? formik.errors.address
                            : undefined
                        }
                        onChange={(e) => {
                          if (
                            e.target?.value.trim() === "" ||
                            e.target?.value === "."
                          ) {
                            formik.setFieldValue("address", "");
                          } else {
                            formik.handleChange(e);
                          }
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                          }
                        }}
                      />
                    </Autocomplete>
                  </div>
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <div className="control_group w_50">
                    <Typography className="custom_label">Select city</Typography >
                    <Select
                      labelId="category-label"
                      value={formik.values.country || ""}
                      id="category-select"
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 250, // Adjust height
                            width: 250,     // Adjust width
                          },
                        },
                      }}
                      name="country"
                      fullWidth
                      displayEmpty
                      onChange={(e) => {
                        formik.setFieldValue("country", e.target.value)
                      }}
                    >
                      <MenuItem value={''} disabled>
                        Select
                      </MenuItem>
                      {places?.length
                        ? places.map((item: any, index) =>
                          item?.value && item?.label ? (
                            <MenuItem value={item.value} key={index}>
                              {item.label}
                            </MenuItem>
                          ) : null // Skip items without value or label
                        )
                        : ""}
                    </Select>
                    {formik.touched.country && formik.errors.country && (
                      <FormHelperText sx={{ color: "red" }}>{String(formik.errors.country)}</FormHelperText>
                    )}
                  </div>
                </Grid>


                {formik.values.offPlanType === "2" ? (
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Typography className="custom_label">Area (Sq.ft)</Typography>
                    <TextField
                      hiddenLabel
                      type={"text"}
                      name="area"
                      className="text_field"
                      variant="outlined"
                      fullWidth
                      placeholder="Enter area"
                      value={formik?.values?.area}
                      onChange={(e) => {
                        const re = /^[0-9]*\.?[0-9]*$/;
                        if (e.target?.value === "" || re.test(e.target?.value)) {
                          formik.handleChange(e);
                        }
                      }}
                      onBlur={formik.handleBlur}
                      error={formik.touched.area && Boolean(formik.errors.area)}
                      inputProps={{
                        inputMode: "decimal",
                      }}
                      helperText={
                        Boolean(formik.touched.area) &&
                        formik.errors.area?.toString()
                      }
                    />
                  </Grid>
                ) : (
                  // <Grid item lg={4} md={4} sm={6} xs={12}></Grid>
                  ""
                )}

                {formik.values.offPlanType === "2" ? (
                  <>
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Typography className="custom_label">Beds</Typography>
                      <Select
                        className="select_div"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        name="beds"
                        fullWidth
                        value={formik?.values?.beds || ""}
                        onChange={(e) =>
                          formik.setFieldValue("beds", e.target?.value)
                        }
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 250, // Adjust height
                              width: 250,     // Adjust width
                            },
                          },
                        }}
                        onBlur={formik.handleBlur}
                        error={formik.touched?.beds && Boolean(formik.errors?.beds)}
                        displayEmpty
                      >
                        <MenuItem value="" disabled>
                          Select
                        </MenuItem>
                        <MenuItem value="0">{formik.values.subCategoryName === 'Apartment' ? "Studio" : "0"}</MenuItem>

                        <MenuItem value="1">1</MenuItem>
                        <MenuItem value="2">2</MenuItem>
                        <MenuItem value="3">3</MenuItem>
                        <MenuItem value="4">4</MenuItem>
                        <MenuItem value="5">5</MenuItem>
                        <MenuItem value="6">6</MenuItem>
                        <MenuItem value="7">7+</MenuItem>
                      </Select>
                      {formik.touched.beds && formik.errors.beds && (
                        <FormHelperText sx={{ color: "red" }}>
                          {String(formik.errors.beds)}
                        </FormHelperText>
                      )}
                    </Grid>

                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Typography className="custom_label">Bathrooms</Typography>
                      <Select
                        className="select_div"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        name="baths"
                        fullWidth
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 250, // Adjust height
                              width: 250,     // Adjust width
                            },
                          },
                        }}
                        value={formik?.values?.baths || ""}
                        onChange={(e) =>
                          formik.setFieldValue("baths", e.target?.value)
                        }
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched?.baths && Boolean(formik.errors?.baths)
                        }
                        displayEmpty
                      >
                        <MenuItem value="" disabled>
                          Select
                        </MenuItem>
                        <MenuItem value="0">0</MenuItem>
                        <MenuItem value="1">1</MenuItem>
                        <MenuItem value="2">2</MenuItem>
                        <MenuItem value="3">3</MenuItem>
                        <MenuItem value="4">4</MenuItem>
                        <MenuItem value="5">5</MenuItem>
                        <MenuItem value="6">6</MenuItem>
                        <MenuItem value="7">7+</MenuItem>
                      </Select>
                      {formik.touched.baths && formik.errors.baths && (
                        <FormHelperText sx={{ color: "red" }}>
                          {String(formik.errors.baths)}
                        </FormHelperText>
                      )}
                    </Grid>
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Typography className="custom_label">
                        Financial Status
                      </Typography>
                      <Select
                        className="select_div"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        name="financialStatus"
                        fullWidth
                        value={formik?.values?.financialStatus || ""}
                        onChange={(e) =>
                          formik.setFieldValue("financialStatus", e.target?.value)
                        }
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched?.financialStatus &&
                          Boolean(formik.errors?.financialStatus)
                        }
                        displayEmpty
                      >
                        <MenuItem value="" disabled>
                          Select
                        </MenuItem>
                        <MenuItem value="1">Cash</MenuItem>
                        <MenuItem value="2">Mortgage</MenuItem>
                      </Select>
                      {formik.touched.financialStatus &&
                        formik.errors.financialStatus && (
                          <FormHelperText sx={{ color: "red" }}>
                            {String(formik.errors.financialStatus)}
                          </FormHelperText>
                        )}
                    </Grid>
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Typography className="custom_label">
                        Available From
                      </Typography>
                      <TextField
                        // hiddenTypography
                        type="date"
                        name="availableDateFrom"
                        variant="outlined"
                        fullWidth
                        placeholder="Start date"
                        className="text_field"
                        inputProps={{ maxLength: 30 }}
                        value={formik.values.availableDateFrom}
                        onChange={handleDateChangeAvlStart}
                        InputProps={{
                          endAdornment: formik.values.availableDateFrom && (
                            <InputAdornment position="end" className="eye_btn">
                              <IconButton
                                onClick={() => {
                                  setStartDate("");
                                  formik.setFieldValue("availableDateFrom", "");
                                }}
                              >
                                <ClearIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                      {formik.touched.availableDateFrom &&
                        formik.errors.availableDateFrom && (
                          <FormHelperText sx={{ color: "red" }}>
                            {String(formik.errors.availableDateFrom)}
                          </FormHelperText>
                        )}
                    </Grid>
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Typography className="custom_label">
                        Available to
                      </Typography>
                      <TextField
                        // hiddenTypography
                        type="date"
                        name="availableDateTo"
                        variant="outlined"
                        fullWidth
                        placeholder="End date"
                        className="text_field"
                        inputProps={{ maxLength: 30, min: today }}
                        value={formik.values.availableDateTo}
                        onChange={handleDateChangeAvlEnd}
                        InputProps={{
                          endAdornment: formik.values.availableDateTo && (
                            <InputAdornment position="end" className="eye_btn">
                              <IconButton
                                onClick={() => {
                                  setEndDate("");
                                  formik.setFieldValue("availableDateTo", "");
                                }}
                              >
                                <ClearIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                      {formik.touched.availableDateTo &&
                        formik.errors.availableDateTo && (
                          <FormHelperText sx={{ color: "red" }}>
                            {String(formik.errors.availableDateTo)}
                          </FormHelperText>
                        )}
                    </Grid>

                  </>
                ) : ("")}
                {formik.values.country === 'dubai' ? (
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Typography className="custom_label">
                      Advertisement Permit Number
                    </Typography>
                    <TextField
                      hiddenLabel
                      type={"text"}
                      name="advertisementPermitNo"
                      className="text_field"
                      variant="outlined"
                      fullWidth
                      placeholder="Enter Permit No "
                      value={formik?.values?.advertisementPermitNo}
                      onChange={(val) => {
                        if (
                          val.target.value === " "

                        ) {
                        } else {
                          formik.handleChange(val);
                        }
                      }}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.advertisementPermitNo &&
                        Boolean(formik.errors.advertisementPermitNo)
                      }
                      helperText={
                        formik.touched.advertisementPermitNo &&
                          typeof formik.errors.advertisementPermitNo === "string"
                          ? formik.errors.advertisementPermitNo
                          : undefined
                      }
                    />
                  </Grid>
                ) : ("")}
                {formik.values.offPlanType === "1" ? (
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">
                      Key Feature
                    </Typography>
                    <TextField
                      hiddenLabel
                      type={"text"}
                      name="keyFeature"
                      className="text_field"
                      variant="outlined"
                      fullWidth
                      multiline
                      style={{ maxHeight: "200px", overflow: "scroll" }}
                      minRows={4}
                      placeholder="Enter Key feature"
                      value={formik?.values?.keyFeature}
                      onChange={(val) => {
                        if (
                          val.target.value === " "

                        ) {
                        } else {
                          formik.handleChange(val);
                        }
                      }}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.keyFeature &&
                        Boolean(formik.errors.keyFeature)
                      }
                      helperText={
                        formik.touched.keyFeature &&
                          typeof formik.errors.keyFeature === "string"
                          ? formik.errors.keyFeature
                          : undefined
                      }
                    />
                  </Grid>
                ) : ("")}



                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography className="custom_label">
                    Description
                  </Typography>
                  {/* <TextField
                    hiddenLabel
                    type={"text"}
                    name="specifications"
                    className="text_field"
                    variant="outlined"
                    fullWidth
                    style={{ maxHeight: "200px", overflow: "scroll" }}
                    multiline
                    minRows={4}
                    placeholder="Enter description"
                    value={formik?.values?.specifications}
                    onChange={(val) => {
                      if (
                        val.target.value === " "

                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.specifications &&
                      Boolean(formik.errors.specifications)
                    }
                    helperText={
                      formik.touched.specifications &&
                        typeof formik.errors.specifications === "string"
                        ? formik.errors.specifications
                        : undefined
                    }
                  /> */}
                  {description?.length || !_id ?
                    <EditText
                      content={description}
                      setContent={setDescription}
                    />
                    :
                    null}
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography className="custom_label">
                    Payment Plan
                  </Typography>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="2"
                    name="radio-buttons-group"
                    className="checkbox_label"
                    value={paymentPlan}
                    onChange={(val) => setPaymentPlan(val.target.value)}
                  >
                    <FormControlLabel value="1" control={<Radio />} label="Yes" />
                    <FormControlLabel value="2" control={<Radio />} label="No" />
                  </RadioGroup>
                </Grid>

                {paymentPlanArray?.length ? (
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className="payment_card_main">
                      {paymentPlanArray?.map((item: PaymentPlanNumber, index: number) => {
                        return (
                          <Card className="cards" style={{ width: "30%" }}>
                            <div className="payment_card">
                              <h4>Payment Option {index + 1}</h4>
                              <Button className="option_delete" onClick={() => handleDeletePaymentObject(index)}>Delete</Button>
                            </div>
                            <div>
                              <h6>Down Payment: <span>{item?.downPaymentPercent}% ({item?.downPaymentInstallments} Installments)</span></h6>
                              <h6>During Construction: <span>{item?.duringConsPercent}% ({item?.duringConsInstallments} Installments)</span></h6>
                              <h6>On Handover: <span>{item?.onHandoverPercent}% ({item?.onHandoverInstallments} Installments)</span></h6>
                            </div>
                          </Card>
                        )
                      })}
                    </div>
                  </Grid>
                ) : null}



                {paymentPlan === "1" && paymentPlanArray?.length < 3 ? (
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Card className="cards" style={{ width: "50%" }} >
                      <Grid container spacing={2}>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography className="custom_label">
                            Down Payment
                          </Typography>
                          <Box className="payment_plan">
                            <TextField
                              hiddenLabel
                              className="text_field"
                              type="text"
                              variant="outlined"
                              fullWidth
                              placeholder="Enter (%)"
                              value={paymentObject.downPaymentPercent}
                              onChange={(e) => {
                                const inputValue = e.target.value;
                                if (/^\d*\.?\d*$/.test(inputValue)) {
                                  setPaymentObject({
                                    ...paymentObject,
                                    downPaymentPercent: inputValue,
                                  });
                                }
                              }}
                            />
                            <TextField
                              hiddenLabel
                              className="text_field"
                              type="text"
                              variant="outlined"
                              fullWidth
                              inputProps={{ maxLength: 3 }}
                              placeholder="Installments"
                              onBlur={formik.handleBlur}
                              value={paymentObject.downPaymentInstallments}
                              onChange={(e) => {
                                const inputValue = e.target.value;
                                if (/^\d*\.?\d*$/.test(inputValue)) {
                                  setPaymentObject({
                                    ...paymentObject,
                                    downPaymentInstallments: inputValue,
                                  });
                                }
                              }}
                            />
                          </Box>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography className="custom_label">
                            During Construction
                          </Typography>
                          <Box className="payment_plan">
                            <TextField
                              hiddenLabel
                              className="text_field"
                              type="text"
                              variant="outlined"
                              fullWidth
                              inputProps={{ maxLength: 3 }}
                              placeholder="Enter (%)"
                              value={paymentObject.duringConsPercent}
                              onChange={(e) => {
                                const inputValue = e.target.value;
                                if (/^\d*\.?\d*$/.test(inputValue)) {
                                  setPaymentObject({
                                    ...paymentObject,
                                    duringConsPercent: inputValue,
                                  });
                                }
                              }}
                            />
                            <TextField
                              hiddenLabel
                              className="text_field"
                              type="text"
                              variant="outlined"
                              fullWidth
                              inputProps={{ maxLength: 3 }}
                              placeholder="Installments"
                              value={paymentObject.duringConsInstallments}
                              onChange={(e) => {
                                const inputValue = e.target.value;
                                if (/^\d*\.?\d*$/.test(inputValue)) {
                                  setPaymentObject({
                                    ...paymentObject,
                                    duringConsInstallments: inputValue,
                                  });
                                }
                              }}
                            />
                          </Box>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography className="custom_label">
                            On Handover
                          </Typography>
                          <Box className="payment_plan">
                            <TextField
                              hiddenLabel
                              className="text_field"
                              type="text"
                              variant="outlined"
                              fullWidth
                              inputProps={{ maxLength: 3 }}
                              placeholder="Enter (%)"
                              value={paymentObject.onHandoverPercent}
                              onChange={(e) => {
                                const inputValue = e.target.value;
                                if (/^\d*\.?\d*$/.test(inputValue)) {
                                  setPaymentObject({
                                    ...paymentObject,
                                    onHandoverPercent: inputValue,
                                  });
                                }
                              }}
                            />
                            <TextField
                              hiddenLabel
                              className="text_field"
                              type="text"
                              variant="outlined"
                              fullWidth
                              inputProps={{ maxLength: 3 }}
                              placeholder="Installments"
                              value={paymentObject.onHandoverInstallments}
                              onChange={(e) => {
                                const inputValue = e.target.value;
                                if (/^\d*\.?\d*$/.test(inputValue)) {
                                  setPaymentObject({
                                    ...paymentObject,
                                    onHandoverInstallments: inputValue,
                                  });
                                }
                              }}
                            />
                          </Box>
                        </Grid>
                        <Button className="btn btn_secondary"
                          onClick={() => handleAddPaymentObject()}
                          style={{
                            marginTop: "10px",
                            marginLeft: "3%"
                          }}>Add</Button>
                      </Grid>
                    </Card>
                  </Grid>
                ) : null}


                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className="cards" style={{ width: "100%" }} >
                    <h4>Add Units</h4>
                    <Grid container spacing={2}>
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <Typography className="custom_label">
                          Beds
                        </Typography>
                        <Box className="payment_plan">
                          <TextField
                            hiddenLabel
                            className="text_field"
                            type="text"
                            variant="outlined"
                            fullWidth
                            inputProps={{ maxLength: 4 }}
                            placeholder="Enter Beds"
                            value={unitsObject.beds}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              if (/^\d*\.?\d*$/.test(inputValue)) {
                                setUnitsObject({
                                  ...unitsObject,
                                  beds: inputValue,
                                });
                              }
                            }}
                          />
                        </Box>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <Typography className="custom_label">
                          Price
                        </Typography>
                        <Box className="payment_plan">
                          <TextField
                            hiddenLabel
                            className="text_field"
                            type="text"
                            variant="outlined"
                            fullWidth
                            placeholder="Enter Price"
                            value={unitsObject.price}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              if (/^\d*\.?\d*$/.test(inputValue)) {
                                setUnitsObject({
                                  ...unitsObject,
                                  price: inputValue,
                                });
                              }
                            }}
                          />

                        </Box>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <Typography className="custom_label">
                          Area (Sq ft)
                        </Typography>
                        <Box className="payment_plan">
                          <TextField
                            hiddenLabel
                            className="text_field"
                            type="text"
                            variant="outlined"
                            fullWidth
                            inputProps={{ maxLength: 6 }}
                            placeholder="Enter area"
                            value={unitsObject.size}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              if (/^\d*\.?\d*$/.test(inputValue)) {
                                setUnitsObject({
                                  ...unitsObject,
                                  size: inputValue,
                                });
                              }
                            }}
                          />
                        </Box>
                      </Grid>
                      {formik.values.offPlanType === "1" ? (
                        <Grid item lg={6} md={6} sm={6} xs={12} />
                      ) : (
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                          <Typography className="custom_label">Enquiry Number</Typography>
                          <Box className="payment_plan">
                            <PhoneInput
                              value={unitsObject.dialCode + unitsObject.enquiryNo}
                              country={"ae"}
                              placeholder="0 (000) 000-000"
                              enableSearch={true}
                              inputStyle={{ width: "100%" }}
                              onChange={(phone, country) =>
                                handleChangePhone(phone, country)
                              }
                            />
                          </Box>
                        </Grid>

                      )}

                      <Button className="btn btn_secondary"
                        onClick={() => handleAddUnits()}
                        style={{
                          marginTop: "10px",
                          marginLeft: "1.5%"
                        }}>Add Unit</Button>
                    </Grid>
                  </Card>
                </Grid>


                {unitsArray?.length ? (
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className="payment_card_main">
                      {unitsArray?.map((item: any, index: number) => {
                        return (
                          <Card className="cards" style={{ width: "30%" }} key={`unit-${index}`}>
                            <div className="payment_card">
                              <h4>Unit {index + 1}</h4>
                              <Button className="option_delete" onClick={() => { handleDeleteUnit(index); setShowLayout(false) }}>
                                <DeleteIcon />
                              </Button>
                              <Button
                                className="option_delete"
                                style={{ background: "black" }}
                                onClick={() => { setIndexForAddLayout(index); setShowLayout(true); }}
                              >
                                Add Layout
                              </Button>
                            </div>
                            <div className="payment_card" style={{ gap: "5px" }}>
                              <h5>{item?.beds || "0"} Beds</h5>
                              <h5>{item?.price || "0"} AED</h5>
                              <h5>{item?.size || "0"} Sq ft</h5>
                              <h5>{item?.dialCode + item?.enquiryNo || ""} </h5>
                            </div>
                            {item?.layouts?.length ? (
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <div className="">
                                  {item?.layouts?.map((layoutItem: any, layoutIndex: number) => {
                                    return (
                                      <Card
                                        className="cards"
                                        style={{ width: "100%", marginTop: "10px" }}
                                        key={`layout-${index}-${layoutIndex}`}
                                      >
                                        <div className="payment_card">
                                          <h4>Layout {layoutIndex + 1}</h4>
                                          <Button className="option_delete" onClick={() => handleDeleteLayout(index, layoutIndex)}>
                                            <DeleteIcon />
                                          </Button>
                                        </div>
                                        <div className="payment_card">
                                          <div>
                                            <h5>{layoutItem?.layoutType}</h5>
                                            <h5>{layoutItem?.size}</h5>
                                          </div>
                                          <div >
                                            {layoutItem?.floorImage ? (
                                              <img
                                                onClick={() => window.open(layoutItem?.floorImage)}
                                                width={"60px"}
                                                src={layoutItem?.floorImage}
                                                alt="floor"
                                              />
                                            ) : null}

                                          </div>
                                        </div>
                                      </Card>
                                    );
                                  })}
                                </div>
                              </Grid>
                            ) : null}
                          </Card>
                        );
                      })}
                    </div>
                  </Grid>
                ) : null}
                {showLayout ? (
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Card className="cards" ref={targetRef} >
                      <h4>Add Layout</h4>
                      <Grid container spacing={2} >
                        <Grid item lg={3} md={3} sm={3} xs={12}>
                          <Typography className="custom_label">
                            Layout Type
                          </Typography>
                          <Box className="payment_plan">
                            <TextField
                              hiddenLabel
                              className="text_field"
                              type="text"
                              variant="outlined"
                              fullWidth

                              placeholder="Enter Type"
                              value={layoutObject.layoutType}
                              onChange={(e) => {
                                setLayoutObject({
                                  ...layoutObject,
                                  layoutType: e.target.value,
                                });

                              }}
                            />
                          </Box>
                        </Grid>
                        <Grid item lg={3} md={3} sm={3} xs={12}>
                          <Typography className="custom_label">
                            Layout Size
                          </Typography>
                          <Box className="payment_plan">
                            <TextField
                              hiddenLabel
                              className="text_field"
                              type="text"
                              variant="outlined"
                              fullWidth

                              placeholder="Enter size"
                              value={layoutObject?.size}
                              onChange={(e) => {
                                const inputValue = e.target.value;
                                if (/^\d*\.?\d*$/.test(inputValue)) {
                                  setLayoutObject({
                                    ...layoutObject,
                                    size: inputValue,
                                  });
                                }
                              }}
                            />

                          </Box>
                        </Grid>
                        <Grid item lg={3} md={3} sm={3} xs={12}>
                          <Typography className="custom_label">
                            Floor Image
                          </Typography>
                          <Box className="upload_image upload_img_dpinf" >
                            <label htmlFor="icon-button-file-vdo" >
                              <Input
                                sx={{ display: "none" }}
                                id="icon-button-file-vdo"
                                type="file"
                                inputProps={{
                                  type: "file",
                                  accept: "image/png,image/jpeg",
                                }}
                                onChange={handleImageUpload1}
                              />
                              <Button component="span" className="upload_image_btn" >
                                <img
                                  style={{
                                    borderRadius: "5px",
                                    width: "220px",
                                    height: "45px",
                                    border: "solid 2px whitesmoke",
                                    objectFit: "contain",
                                  }}
                                  onClick={() =>
                                    layoutObject.floorImage ? window.open(layoutObject.floorImage) : null
                                  }
                                  src={
                                    layoutObject.floorImage
                                      ? layoutObject.floorImage
                                      : "/static/images/upload.png"
                                  }
                                  alt=""
                                />
                              </Button>
                            </label>
                            <div className="close_btn_abs">
                              {layoutObject.floorImage ? (
                                <IconButton
                                  onClick={() => setLayoutObject({ ...layoutObject, floorImage: "" })}
                                >
                                  <ClearIcon />
                                </IconButton>
                              ) : (
                                ""
                              )}
                            </div>
                          </Box>
                        </Grid>
                        <Grid item lg={1} md={1} sm={1} xs={12}>
                          <Button style={{ marginTop: "23px" }} onClick={() => handleAddLayout(indexForAddLayout)} className="btn btn_secondary">Add</Button>
                        </Grid>
                      </Grid>
                    </Card>
                  </Grid>
                ) : null}

                {formik.values.offPlanType === "2" ? (
                  <div className="doc_div" >
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                      <Typography className="custom_label">
                        Floor Plan (pdf format)
                      </Typography>
                      <Box className="upload_image upload_img_dpinf">
                        <label htmlFor="icon-button-file-vdo-1">
                          <Input
                            sx={{ display: "none" }}
                            id="icon-button-file-vdo-1"
                            type="file"
                            inputProps={{
                              type: "file",
                              accept: "application/pdf",
                            }}

                            onChange={(e) => handlePdfUpload(e as React.ChangeEvent<HTMLInputElement>, "floorPlan")}
                          />
                          <Button component="span" className="upload_image_btn">
                            <img
                              style={{
                                borderRadius: "5px",
                                width: "300px",
                                height: "200px",
                                border: "dashed 3px lightgrey",
                                objectFit: "contain",
                              }}
                              onClick={() =>
                                formik.values.floorPlan ? window.open(formik.values.floorPlan) : null
                              }
                              src={
                                formik.values.floorPlan
                                  ? "/static/images/pdf.png"
                                  : "/static/images/upload.png"
                              }
                              alt=""
                            />
                          </Button>
                        </label>
                        <div className="close_btn_abs">
                          {formik.values.floorPlan ? (
                            <IconButton
                              onClick={() => formik.setFieldValue("floorPlan", "")}
                            >
                              <ClearIcon />
                            </IconButton>
                          ) : (
                            ""
                          )}
                        </div>
                      </Box>
                      {formik.touched.floorPlan &&
                        typeof formik.errors.floorPlan === "string" && (
                          <Typography
                            sx={{ fontSize: "12px" }}
                            variant="caption"
                            color="red"
                          >
                            {formik.errors.floorPlan}
                          </Typography>
                        )}
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                      <Typography className="custom_label">
                        SPA or OQOOD (pdf format)
                      </Typography>
                      <Box className="upload_image upload_img_dpinf">
                        <label htmlFor="icon-button-file-vdo-2">
                          <Input
                            sx={{ display: "none" }}
                            id="icon-button-file-vdo-2"
                            type="file"
                            inputProps={{
                              type: "file",
                              accept: "application/pdf",
                            }}

                            onChange={(e) => handlePdfUpload(e as React.ChangeEvent<HTMLInputElement>, "SPA")}
                          />
                          <Button component="span" className="upload_image_btn">
                            <img
                              style={{
                                borderRadius: "5px",
                                width: "300px",
                                height: "200px",
                                border: "dashed 3px lightgrey",
                                objectFit: "contain",
                              }}
                              onClick={() =>
                                formik.values.SPA ? window.open(formik.values.SPA) : null
                              }
                              src={
                                formik.values.SPA
                                  ? "/static/images/pdf.png"
                                  : "/static/images/upload.png"
                              }
                              alt=""
                            />
                          </Button>
                        </label>
                        <div className="close_btn_abs">
                          {formik.values.SPA ? (
                            <IconButton
                              onClick={() => formik.setFieldValue("SPA", "")}
                            >
                              <ClearIcon />
                            </IconButton>
                          ) : (
                            ""
                          )}
                        </div>
                      </Box>
                      {formik.touched.SPA &&
                        typeof formik.errors.SPA === "string" && (
                          <Typography
                            sx={{ fontSize: "12px" }}
                            variant="caption"
                            color="red"
                          >
                            {formik.errors.SPA}
                          </Typography>
                        )}
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                      <Typography className="custom_label">
                        Project Brochure (pdf format)
                      </Typography>
                      <Box className="upload_image upload_img_dpinf">
                        <label htmlFor="icon-button-file-vdo-3">
                          <Input
                            sx={{ display: "none" }}
                            id="icon-button-file-vdo-3"
                            type="file"
                            inputProps={{
                              type: "file",
                              accept: "application/pdf",
                            }}

                            onChange={(e) => handlePdfUpload(e as React.ChangeEvent<HTMLInputElement>, "projectBrochure")}
                          />
                          <Button component="span" className="upload_image_btn">
                            <img
                              style={{
                                borderRadius: "5px",
                                width: "300px",
                                height: "200px",
                                border: "dashed 3px lightgrey",
                                objectFit: "contain",
                              }}
                              onClick={() =>
                                formik.values.projectBrochure ? window.open(formik.values.projectBrochure) : null
                              }
                              src={
                                formik.values.projectBrochure
                                  ? "/static/images/pdf.png"
                                  : "/static/images/upload.png"
                              }
                              alt=""
                            />
                          </Button>
                        </label>
                        <div className="close_btn_abs">
                          {formik.values.projectBrochure ? (
                            <IconButton
                              onClick={() => formik.setFieldValue("projectBrochure", "")}
                            >
                              <ClearIcon />
                            </IconButton>
                          ) : (
                            ""
                          )}
                        </div>
                      </Box>
                      {formik.touched.projectBrochure &&
                        typeof formik.errors.projectBrochure === "string" && (
                          <Typography
                            sx={{ fontSize: "12px" }}
                            variant="caption"
                            color="red"
                          >
                            {formik.errors.projectBrochure}
                          </Typography>
                        )}
                    </Grid>
                  </div>
                ) : ("")}




              </Grid>
              <div className="form_btn">
                <Button type="submit" className="btn btn_primary">
                  Save
                </Button>
                {Boolean(searchParams?.get("draft")) && (
                  <Button className="btn btn_secondary" onClick={saveDraft}>
                    Save as draft
                  </Button>
                )}
                {!_id && (
                  <Button className="btn btn_secondary" onClick={saveDraft}>
                    Save as draft
                  </Button>
                )}
              </div>
            </CardContent>
          </form>
        </Card>

      </div >
    </div >
  );
};

export default AddOffPlanProperty;
